module.exports = __webpack_public_path__ + "BgHeaderShop.jpg?155913adf16113dfd0a567dc165f778f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BgHeaderShop.jpg
// module id = 86
// module chunks = 0